// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"ca331c0a","78":"57faa251","453":"300227d8","982":"d2976065"}[chunkId] + ".chunk.js";
};